export default "__VITE_ASSET__e7df7b01__"